import {
    FETCH_SUPPLIERS_SUCCESS,
    FETCH_SUPPLIER_BY_ID_SUCCESS,

    FETCH_SUPPLIERS_CONTACTS_SUCCESS,
    FETCH_SUPPLIERS_CONTACTS_CREATE_SUCCESS,
    FETCH_SUPPLIERS_CONTACTS_DELETE_SUCCESS,

    FETCH_SUPPLIERS_USERS_GET_SUCCESS,
    FETCH_SUPPLIERS_USERS_CREATE_SUCCESS,
    FETCH_SUPPLIERS_USERS_DELETE_SUCCESS,

    SUPPLIER_REQUEST_LOADING,
    SUPPLIER_REQUEST_ERRORS,
} from "api/menu/master-files/suppliers/actions";

const initialState = {
    loading: false,
    errors: [],

    suppliers: [],
    singleSupplier: {},

    singleSupplierContacts: [],

    users: []
};

export default function(state = initialState, action) {
    let singleSupplierContacts = [],
        users = [],
        index;
    switch (action.type) {
        case SUPPLIER_REQUEST_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case SUPPLIER_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case FETCH_SUPPLIERS_SUCCESS:
            return {
                ...state,
                loading: false,
                suppliers: action.payload
            };
        case FETCH_SUPPLIER_BY_ID_SUCCESS:
            return {
                ...state,
                errors: [],
                loading: false,
                singleSupplier: action.payload,
                singleSupplierContacts: Object.keys(action.payload).length
                    ? state.singleSupplierContacts
                    : []
            };
        case FETCH_SUPPLIERS_CONTACTS_SUCCESS:
            return {
                ...state,
                errors: [],
                loading: false,
                singleSupplierContacts: action.payload
            };
        case FETCH_SUPPLIERS_CONTACTS_CREATE_SUCCESS:
            singleSupplierContacts = Object.assign([], state.singleSupplierContacts);
            index = singleSupplierContacts
                .findIndex(item => parseInt(item.id, 10) === action.payload.id);
            if (index > -1) {
                singleSupplierContacts[index] = action.payload;
            } else {
                singleSupplierContacts.push(action.payload);
            }
            return {
                ...state,
                errors: [],
                loading: false,
                singleSupplierContacts
            };
        case FETCH_SUPPLIERS_CONTACTS_DELETE_SUCCESS:
            singleSupplierContacts = Object.assign([], state.singleSupplierContacts);
            index = singleSupplierContacts.findIndex(item => item.id === action.payload);
            if (index > -1) {
                singleSupplierContacts.splice(index, 1);
            }
            return {
                ...state,
                errors: [],
                loading: false,
                singleSupplierContacts
            };
        case FETCH_SUPPLIERS_USERS_GET_SUCCESS:
            return {
                ...state,
                errors: [],
                loading: false,
                users: action.payload
            };
        case FETCH_SUPPLIERS_USERS_CREATE_SUCCESS:
            users = Object.assign([], state.users);
            index = users
                .findIndex(item => parseInt(item.id, 10) === action.payload.id);
            if (index > -1) {
                users[index] = action.payload;
            } else {
                users.push(action.payload);
            }
            return {
                ...state,
                errors: [],
                loading: false,
                users
            };
        case FETCH_SUPPLIERS_USERS_DELETE_SUCCESS:
            users = Object.assign([], state.users);
            index = users.findIndex(item => item.id === action.payload.id);
            if (index > -1) {
                users.splice(index, 1);
            }
            return {
                ...state,
                errors: [],
                loading: false,
                users
            };
        default:
            return state;
    }
}
